const BOSS_S_URL = process.env.BOSS_S_ENDPOINT

/**
 * BOSS-Sに関わる定数・処理をまとめたmixin
 */
export default {
  computed: {
    bossSEndPoint: () => BOSS_S_URL,
    isPrePublishedAccess () {
      return this.$route.name.includes('PrePublished')
    },
    isCompanyStaffAccess () {
      return !this.$route.name.startsWith('bossS')
    },
    isEditingAccess () {
      return !this.isCompanyStaffAccess && this.$route.name.includes('Editing')
    },
    companyId () { return this.$route.params.companyId },
    jobId () { return this.$route.params.jobId },
    offerId () { return this.$route.params.offerId },
    apiPath () {
      return this.judgementAccess(
        `/preview/prepublish/jobs/${this.jobId}`,
        `/preview/publish/jobs/${this.offerId}`,
        `/preview/prepublish/companies/${this.companyId}/jobs/${this.jobId}`,
        `/preview/prepublish/companies/${this.companyId}/jobs/${this.jobId}`,
        `/preview/publish/companies/${this.companyId}/jobs/${this.offerId}`
      )
    },
    apiPathForFetchJobs () {
      return this.judgementAccess(
        this.apiPath,
        this.apiPath,
        `${this.apiPath}/editing`,
        `${this.apiPath}/confirm`,
        this.apiPath
      )
    },
    spRouteNameForJob () {
      return this.judgementAccess(
        'jobPrePublishedPreviewSp',
        'jobPublishedPreviewSp',
        'bossSPrePublishedEditingJobPreviewSp',
        'bossSPrePublishedConfirmJobPreviewSp',
        'bossSPublishedJobPreviewSp'
      )
    },
    apiPathForJobSearch () {
      return this.judgementAccess(
        `/preview/prepublish/search/${this.jobId}`,
        `/preview/publish/search/${this.offerId}`,
        `/preview/prepublish/companies/${this.companyId}/search/${this.jobId}/editing`,
        `/preview/prepublish/companies/${this.companyId}/search/${this.jobId}/confirm`,
        '' // bossS掲載済み導線はないため不要
      )
    },
    spRouteNameForJobSearch () {
      return this.judgementAccess(
        'jobSearchPrePublishedPreviewSp',
        'jobSearchPublishedPreviewSp',
        'bossSPrePublishedEditingJobSearchPreviewSp',
        'bossSPrePublishedConfirmJobSearchPreviewSp',
        '' // bossS掲載済み導線はないため不要
      )
    },
    apiPathForPhotoClip () {
      return this.judgementAccess(
        `/preview/prepublish/photoclips/${this.id}`,
        `/preview/publish/photoclips/${this.id}`,
        `/preview/prepublish/companies/${this.companyId}/photoclips/${this.id}/editing`,
        `/preview/prepublish/companies/${this.companyId}/photoclips/${this.id}/confirm`,
        `/preview/publish/companies/${this.companyId}/photoclips/${this.id}`
      )
    },
    spRouteNameForPhotoClip () {
      return this.judgementAccess(
        'photoClipPrePublishedPreviewSp',
        'photoClipPublishedPreviewSp',
        'bossSPrePublishedEditingPhotoClipPreviewSp',
        'bossSPrePublishedConfirmPhotoClipPreviewSp',
        'bossSPublishedPhotoClipPreviewSp'
      )
    },
    apiPathForInterview () {
      return this.judgementAccess(
        `/preview/prepublish/interviews/${this.id}`,
        `/preview/publish/interviews/${this.id}`,
        `/preview/prepublish/companies/${this.companyId}/interviews/${this.id}/editing`,
        `/preview/prepublish/companies/${this.companyId}/interviews/${this.id}/confirm`,
        `/preview/publish/companies/${this.companyId}/interviews/${this.id}`
      )
    },
    spRouteNameForInterview () {
      return this.judgementAccess(
        'interviewPrePublishedPreviewSp',
        'interviewPublishedPreviewSp',
        'bossSPrePublishedEditingInterviewPreviewSp',
        'bossSPrePublishedConfirmInterviewPreviewSp',
        'bossSPublishedInterviewPreviewSp'
      )
    },
    apiPathForCompany () {
      if (this.isCompanyStaffAccess) {
        // BOSS-C 企業情報プレビューからのアクセス
        return `/preview/prepublish/companies/${this.id}`
      } else if (this.isEditingAccess) {
        // BOSS-S 編集中企業情報からのアクセス
        return `/preview/companies/${this.id}/editing`
      } else {
        // BOSS-S 確定企業情報からのアクセス
        return `/preview/companies/${this.id}/confirm`
      }
    },
    spRouteNameForCompany () {
      if (this.isCompanyStaffAccess) {
        // BOSS-C 企業情報プレビューからのアクセス
        return 'companyPreviewSp'
      } else if (this.isEditingAccess) {
        // BOSS-S 編集中企業情報からのアクセス
        return 'bossSEditingCompanyPreviewSp'
      } else {
        // BOSS-S 確定企業情報からのアクセス
        return 'bossSConfirmCompanyPreviewSp'
      }
    }
  },
  methods: {
    openBossSAgeRegulation () {
      window.open(`${this.bossSEndPoint}/web-adm/th/common/pdf/ageRegulation.pdf`, '_blank')
    },
    openBossSPRCodes () {
      const id = this.isPrePublishedAccess ? this.jobId : this.offerId
      const isOffmFlg = this.isPrePublishedAccess
      window.open(`${this.bossSEndPoint}/web-adm/offer/preview/${id}/pr/?isOffmFlg=${isOffmFlg}`, '_blank', 'height=550,width=1100')
    },
    judgementAccess (bossCPrePublished, bossCPublished, bossSPrePublishedEditing, bossSPrePublishedConfirm, bossSPublished) {
      if (this.isCompanyStaffAccess) { // BOSS-C
        if (this.isPrePublishedAccess) { // 掲載前
          return bossCPrePublished
        } else { // 掲載済み
          return bossCPublished
        }
      } else { // BOSS-S
        if (this.isPrePublishedAccess) { // 掲載前
          return this.isEditingAccess ? bossSPrePublishedEditing : bossSPrePublishedConfirm
        } else { // 掲載済み
          return bossSPublished
        }
      }
    }
  }
}
